import React, { useEffect, useMemo, useState } from "react";
import { Spin, Table } from "antd";

import PredeterminationPatientSubTable from "./PredeterminationPatientSubTable";
import AddPatientModal from "../AddPatientModal";
import PatientDropdown from "./PatientDropdown";
import AIProcessing from "./AIProcessing";

// `patients` are the patients that extracted from uploaded files, `allPatients` is the all office patients.
export default function PredeterminationPatientsTable({
  status,
  patient,
  patients,
  isApproved,
  isApproving,
  allPatients,
  allProcedures,
  allPaymentTypes,
  insuranceStatus,
  approvedPatients,
  selectedInsurance,
  setMarkedProcedures,
  selectedPaymentType,
  handleApproveInsurance,
  isApprovingPostPayment,
  setSelectedPaymentType,
  handleApprovePostPayment,
  predeterminationOrPostPayment,
}) {
  const [showAddPatient, setShowAddPatient] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [tablePageIndex, setTablePageIndex] = useState(1);
  const allRowKeys = useMemo(() => patients.map((patient) => patient.id), [patients]);

  useEffect(() => {
    setExpandedKeys(allRowKeys);
  }, [allRowKeys]);

  console.log(allRowKeys);

  const patientInsurancesDetailsColumns = [
    {
      title: "ID",
      key: "id",
      width: 100,
      render: (text, record, index, pageIndex) => {
        const pageSize = 10;
        return (tablePageIndex - 1) * pageSize + index + 1;
      },
    },
    {
      title: "Patient",
      key: "patient_name",
      width: 330,
      render: (_, record) => {
        // Check if any insurance has the patient full name
        const hasFullName = record.insurances.every((insurance) => insurance.temp_patient_full_name !== null);

        if (hasFullName) {
          for (let i = 0; i < record.insurances.length; i++) {
            if (record.insurances[i].temp_patient_full_name !== null) return record.insurances[i].temp_patient_full_name;
          }
        } else {
          return `${record.first_name} ${record.last_name}`;
        }
      },
    },
    {
      title: "Related Patient",
      key: "patient_id",
      width: 330,
      render: (_, record) => (
        <PatientDropdown setShowAddPatient={setShowAddPatient} allPatients={allPatients} currentPatient={record} patient={patient} />
      ),
    },
    {
      title: "Total Amount",
      key: "total_amount",
      width: 330,
      render: (_, record) => {
        if (!record.insurances || record.insurances.length === 0) return "-";
        const total = record.insurances.reduce((sum, insurance) => {
          return sum + parseFloat(insurance.estimated_cost || 0);
        }, 0);
        return `$${total.toFixed(2)}`;
      },
    },
    {
      title: "Insurance Count",
      key: "insurance_count",
      width: 150,
      render: (_, record) => (record.insurances && record.insurances.length) || 0,
    },
  ];

  const paginationConfig = {
    current: tablePageIndex,
    pageSize: 10,
    onChange: (page) => setTablePageIndex(page),
    position: ["bottomCenter"],
  };

  return (
    <div style={{ borderRadius: 8 }} className="insurance-treatment-table-container">
      {status === "processing" && <AIProcessing />}

      {/* Show a blur window on top of the table to show that insurance is approving */}
      {isApproving && (
        <div className="predetermination-spinner-container">
          <Spin size="large" />
        </div>
      )}

      <Table
        rowKey="id"
        dataSource={patients}
        columns={patientInsurancesDetailsColumns}
        pagination={paginationConfig}
        scroll={{ x: 1000 }}
        expandable={{
          expandedRowRender: (record) => (
            <PredeterminationPatientSubTable
              predeterminationOrPostPayment={predeterminationOrPostPayment}
              handleApprovePostPayment={handleApprovePostPayment}
              isApprovingPostPayment={isApprovingPostPayment}
              setSelectedPaymentType={setSelectedPaymentType}
              handleApproveInsurance={handleApproveInsurance}
              selectedPaymentType={selectedPaymentType}
              setMarkedProcedures={setMarkedProcedures}
              selectedInsurance={selectedInsurance}
              approvedPatients={approvedPatients}
              allPaymentTypes={allPaymentTypes}
              insuranceStatus={insuranceStatus}
              allProcedures={allProcedures}
              isApproved={isApproved}
              loading={isApproving}
              record={record}
            />
          ),
          rowExpandable: (record) => record.insurances && record.insurances.length > 0,
          expandedRowKeys: expandedKeys, // Controlled keys
          onExpand: (expanded, record) => {
            // Handle user expand/collapse manually to update state
            setExpandedKeys((prevKeys) => (expanded ? [...prevKeys, record.id] : prevKeys.filter((key) => key !== record.id)));
          },
        }}
      />

      <AddPatientModal showAddPatient={showAddPatient} setShowAddPatient={setShowAddPatient} />
    </div>
  );
}
